import { FontLineHeightMd, FontWeightDefault, FontSize100, ColorTextError, SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
const InputErrorStyles = () => ({
  errorText: {
    display: "flex",
    flexDirection: "row",
    alignItems: "start",
    gap: SpaceXxs,
    color: ColorTextError,
    fontSize: FontSize100,
    fontWeight: FontWeightDefault,
    lineHeight: FontLineHeightMd,
    wordWrap: "break-word",
    svg: {
      marginTop: "2px",
      height: "14px",
      width: "14px"
    }
  }
});
export {
  InputErrorStyles
};
